import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_50 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

/**
 * Post Engagements KPI Configuration for Media Viewer
 * Row 8: Post Engagements (Computed: totalLikes+totalReplies+totalReposts+totalQuotes+totalBookmarks)
 */
export const mediaViewerPostEngagementsConfig: KpiType<
    typeof MediaViewerKpiLoader,
    typeof KPIDefault
> = {
    name: 'kpi.twitter.mediaviewer.post_engagements',
    id: 'engagements',
    icon: {
        name: 'engagement',
        style: colors.green
    },
    tooltip: null,
    orientation: ORIENTATION_VERTICAL,
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_50,
    type: 'kpi',
    element: KPIDefault,
    loader: MediaViewerKpiLoader
};
